<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page mb-4 text-white">Resource Management</div>
          <lms-button class="mr-2 " @click="$emit('create-admin-asset')"
            >Add Resource</lms-button
          >
          <lms-button @click="$emit('create-lesson')">Add Lesson</lms-button>
        </div>
        <div>
          <img :src="require('../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>

    <lcontainer>
      <div v-if="value == 'resource'">
        <div class="flex">
          <page-header
            @click="swap('resource')"
            :class="value == 'resource' ? 'active_tab' : ''"
            class="py-2 main-tenant-color cursor-pointer"
            >Resources</page-header
          >
          <page-header
            @click="swap('lesson')"
            :class="value == 'lesson' ? 'active_tab' : ''"
            class="py-2 main-tenant-color cursor-pointer"
            >Lessons</page-header
          >
        </div>
        <hr class="mx-4" />
        <div class="mx-8 mt-4">
          <linput
            v-model="search"
            class="py-2"
            placeholder="Search by Resource Name"
          />
        </div>
        <div class="flex flex-wrap">
          <div
            v-for="(asset, i) in searchAssets"
            :key="i"
            class="w-full md:w-1/4 "
          >
            <asset-card :asset="asset" class="my-4 mx-2" />
          </div>
        </div>
        <div />
      </div>

      <div v-if="value == 'lesson'">
        <div class="flex">
          <page-header
            @click="swap('resource')"
            :class="value == 'resource' ? 'active_tab' : ''"
            class="py-2 main-tenant-color cursor-pointer"
            >Resources</page-header
          >
          <page-header
            @click="swap('lesson')"
            :class="value == 'lesson' ? 'active_tab' : ''"
            class="py-2 main-tenant-color cursor-pointer"
            >Lessons</page-header
          >
        </div>
        <hr class="mx-4" />
        <div class="mx-8 mt-4">
          <linput
            v-model="search"
            class="py-2"
            placeholder="Search by Lesson Name"
          />
        </div>
        <div />
        <div class="flex flex-wrap">
          <div
            v-for="(lesson, i) in searchLessons"
            :key="i"
            class="w-full md:w-1/4 "
          >
            <lesson-card :lesson="lesson" class="my-4 mx-2" />
          </div>
        </div>
        <div />
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    AssetCard: () => import("@/components/admin/asset-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
    LessonCard: () => import("@/components/admin/lesson-card"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      value: "resource",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchAdminAssets", "adminFetchLesson"]),
    swap(val) {
      //console.log({ val });
      this.value = val;
    },
  },
  computed: {
    ...mapGetters(["getAdminAssets", "getAdminLesson"]),
    searchAssets() {
      return this.getAdminAssets.filter((asset) => {
        return asset.asset_name.toLowerCase().match(this.search.toLowerCase());
      });
    },
    searchLessons() {
      return this.getAdminLesson.filter((asset) => {
        return asset.title.toLowerCase().match(this.search.toLowerCase());
      });
    },
  },
  async mounted() {
    await this.fetchAdminAssets();
    await this.adminFetchLesson();
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/main.scss";
.active_tab {
  border-bottom: 2px solid color(tenant-main-color);
}
</style>
